import React, {Component, Fragment} from "react";
import { multimediaEpaycoUrl } from "../../utils/multimedia";
import {Flex, Mycard, Elastic, Transition, MyCampo} from "../ui";
import {Btn} from "./../UI-Components/Btn";
import {withRouter} from "react-router";
/** @jsx jsx */
import {jsx, css} from '@emotion/core';
import {serviceApiResponse} from "../ServiciosMaestros/request";
import {api} from "../ServiciosMaestros/apis";
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SimpleReactValidator from 'simple-react-validator';
import CustomizedSnackbars from '../Helpers/Alerts'
import AlertDialog from '../Helpers/Dialog'
import MyRadio from '../Helpers/Radios'
import FacturaC2 from "./facturaComp/FacturaComp2/facturaComp2";


import {Check,Datos} from "./helpers_styles";
import {ConFacturaCard} from "../UI-Components/layoutComponents/styles";

toast.configure({
    autoClose: 5000,
    draggable: true,
});

const total = css`
    font-size:18px;
    font-weight:bold;
`;

const FooterL = (props) => {
    return (
        <Flex className={"py-2 px-lg-4"}>
            <div className="col-12 col-md-7 col-xl-8 cg px-0">
                <div className="col-12 py-3">
                    <p className={"mb-0"} css={total}>Total a pagar :
                        ${parseFloat(props.total).toLocaleString('en-US', {minimumFractionDigits: 0})} {props.moneda}</p>
                </div>
            </div>
            <div className="col-12 col-md-5 col-xl-4 px-0">
                <div className="col-12">
                    {
                        props.disableButton &&
                        <Btn className={props.loading ? "loading" : ""}
                             disabled={props.loading}
                             onClick={() => props.pagarFacturas()}
                        >
                            {props.loading ? "" : "Pagar seleccionados"}
                        </Btn>
                    }
                </div>
            </div>
        </Flex>
    )
};



export const Mycheck = ({active, clickCheck, value, all = false, abonar = false, white}) => {

    return (
        <Check active={active} white={white} abonar={abonar}>
            <div className={"check"}>
                <img src={multimediaEpaycoUrl("/dashboard/recaudo/proyecto/imagenes/check.png")}
                     alt=""

                />
            </div>
            <input type="checkbox" onClick={() => clickCheck(value, all)}/>
        </Check>
    )
};

const AbonoMultiplesValores = (props) => {

    return props.facturas.map((fac, key) => {
        return (
            <Flex className={"px-lg-3 mb-3"} alg="stretch" key={"factura" + key}>
                <Flex className={"col-12 py-md-1 px-0"} css={Datos} alg={"stretch"}>
                    <Flex className="col-2 col-md-1 px-0 main-check" direction={"colunm"}>
                        <Mycheck
                            active={props.checks.length > 0 ? props.checks[key] : false}
                            clickCheck={props.clickCheck.bind(this)} value={key}
                        />
                    </Flex>
                    <Flex className="px-0" alg={"stretch"} jc={"flex-start"} elastic="1 0 115px">
                        {fac.map((it, key2) => {
                            if (it.entidad === 'facturaId') {
                                return (
                                    <Flex
                                        direction={"column"}
                                        alg={"flex-start"}
                                        key={"it" + key2}
                                        className={`py-2 dato f02 px-3`}
                                        elastic="1 0 115px"
                                    >
                                        <b>{it.titulo}</b>
                                        <p className={"mb-0 cg "}>
                                            {it.valor}
                                        </p>
                                    </Flex>
                                )
                            }
                        })}
                        <Flex className={`col-12
                             col-md-8

                            dato`}
                              alg={"flex-end"}
                        >
                            <div className={`col-12 px-0`}>
                                <div className={"wc text-center"}>

                                    {/* <Mycheck
                                            abonar={props.abonarFactura}
                                            active={props.checksOtroValor.length > 0 ? props.checksOtroValor[key] : false}
                                            clickCheck={props.clickCheckOtroValor.bind(this)}
                                            value={key}/> */}
                                </div>

                                <Flex className="wc px-3 pb-2" alg={"flex-end"}>
                                    <Flex className={"text-center"} elastic={"1 0 100px"}>
                                        <div className="text-center p-0">
                                            <MyRadio color="primary"
                                                     name={'MyRadio'}
                                                     onChange={props.clickCheckOtroValor.bind(this)}
                                                     checked={props.checksOtroValor.length > 0 ? props.checksOtroValor[key] : false}
                                                     value={key}
                                            />
                                        </div>
                                        <div className={"wc text-center"}>
                                            <b>Otro valor</b>
                                        </div>
                                        <Flex elastic={"1 0 150px"}>
                                            <MyCampo
                                                type="mount"
                                                // label={"Otro valor"}
                                                placeholder={"Otro valor"}
                                                value={props.valuesOtroValor[key]}
                                                name={key}
                                                onChangeValor={props.onChangeOtroValor.bind(this)}
                                                obligatory={false}
                                                // configuracionCampos={conf.fieldTypes}
                                                disabled={!props.checksOtroValor[key]}
                                                // error={error}
                                                bordeAzul
                                            />
                                        </Flex>
                                    </Flex>
                                    <Flex direction={"colunm"}
                                          onClick={() => props.salirCambiarPantalla()}
                                          elastic={"0 0 80px"}
                                          className={"pl-3 pb-2"}
                                    >
                                        <i
                                            className={`fa fa-arrow-left fa-lg ml-1 icon-back-arrow`}
                                        />
                                        <p className={"ct mb-0 pl-2 back-text-dynamic"}>Atrás</p>
                                    </Flex>
                                </Flex>
                            </div>

                        </Flex>
                    </Flex>
                </Flex>
            </Flex>
        )
    })
};


const Factura = (data) => {
    function opcionFacturas(props){

        let  opcionRcdo = props.opcionesRecaudo !== "" && props.opcionesRecaudo;

        if (opcionRcdo && (props.opcionesRecaudo.agruparFacturas.activo || props.opcionesRecaudo.modificarValorPagar.activo)) {
        if (props.opcionesRecaudo.agruparFacturas.activo && props.opcionesRecaudo.modificarValorPagar.activo) {
                if (props.opcionesRecadudo.multiplesValoresPago.activo || props.opcionesRecadudo.fechasVencimiento.activo) {
                    return (
                        <Fragment>
                            {props.facturas.map((fac, key) => {
                                return <FacturaC2 fac={fac} key={key} id={key} props={props} />
                            })}
                        </Fragment>
                    )
                } else {
                    return (
                        <div className={"wc"}>
                            {props.facturas.map((fac, key) => {
                                return (
                                    <Flex className={"px-lg-3 mb-3"} alg="stretch" key={"factura" + key}>
                                        <Flex className={"col-12 col-md-9 contenedorBlanco col-lg-10 py-md-1"} css={Datos}>
                                            <Flex className="col-2 col-md-1" direction={"colunm"}>
                                                <Mycheck
                                                    active={props.checks.length > 0 ? props.checks[key] : false}
                                                    clickCheck={props.clickCheck.bind(this)} value={key}
                                                />
                                            </Flex>


                                            <Flex className="col-10 col-md-11 px-0">
                                                {fac.map((it, key2) => {
                                                    if (key2 === 0) {
                                                        return (
                                                            <div
                                                                key={"it" + key2}
                                                                className={
                                                                    props.opcionesRecaudo !== "" &&
                                                                    props.opcionesRecaudo &&
                                                                    (props.opcionesRecadudo.multiplesValoresPago.activo ||
                                                                        props.opcionesRecadudo.fechasVencimiento.activo) ?
                                                                        `col-12 col-md-4 py-2 dato height-100-display-flex` :
                                                                        `col-12 col-md-6 py-2 dato height-100-display-flex`
                                                                }
                                                            >
                                                                <Flex direction={"colunm"}>
                                                                    <i
                                                                        onClick={() => props.showModal(key)}
                                                                        className={`fa fa-info-circle fa-lg icon-info-circle`}
                                                                    />
                                                                </Flex>

                                                                {props.tituloFactura === it.titulo &&
                                                                <MyRadio color="primary"
                                                                         name={'MyRadio'}
                                                                         onChange={props.clickCheck.bind(this)}
                                                                         checked={props.checks.length > 0 ? props.checks[key] : false}
                                                                         value={key}
                                                                />}
                                                                <b>{it.titulo}</b>
                                                                <p className={"mb-0 cg description "}>{it.valor}</p>
                                                            </div>
                                                        )
                                                    } else {
                                                        return (
                                                            <div
                                                                key={"it" + key2}
                                                                className={`col-12 col-md-4 py-2 dato height-100`}
                                                            >
                                                                {props.tituloFactura === it.titulo &&
                                                                <div>
                                                                    <MyRadio color="primary"
                                                                             name={'MyRadio'}
                                                                             onChange={it.opcion === 1 ? props.clickCheckValor1.bind(this) : ""}
                                                                             checked={props[`checksValor1`].length > 0 ? props[`checksValor1`][key] : false}
                                                                             value={key}
                                                                    />
                                                                </div>
                                                                }
                                                                <b>{it.titulo}</b>
                                                                <p className={"mb-0 cg description "}>
                                                                    {it.valor}
                                                                </p>
                                                            </div>
                                                        )
                                                    }
                                                })
                                                }
                                                {props.opcionesRecaudo != "" && props.opcionesRecaudo.modificarValorPagar.activo &&
                                                <div
                                                    className={`col-12 col-md-4 py-2 py-md-0 dato`}
                                                >
                                                    <div>
                                                        <MyRadio color="primary"
                                                                 name={'MyRadio'}
                                                                 onChange={props.clickCheckOtroValor.bind(this)}
                                                                 checked={props.checksOtroValor.length > 0 ? props.checksOtroValor[key] : false}
                                                                 value={key}
                                                        />
                                                    </div>
                                                    <b>Otro valor</b>
                                                    <MyCampo
                                                        type="mount"
                                                        placeholder={"Otro valor"}
                                                        value={props.valuesOtroValor[key]}
                                                        name={key}
                                                        onChangeValor={props.onChangeOtroValor.bind(this)}
                                                        obligatory={false}
                                                    />
                                                </div>}
                                            </Flex>


                                        </Flex>
                                        <div
                                            className="col-12 col-lg-2 pt-2 pt-md-0 px-0 pl-md-3 col-md-3 ml-md-auto mr-md-0 ">
                                            <Btn onClick={() => props.pagar(key)}
                                                 brdr={"12px"}
                                                 hg={"100%"}
                                                 className={"py-2 py-lg-0 hc"}> PAGAR
                                            </Btn>
                                        </div>
                                    </Flex>
                                )
                            })}
                        </div>
                    )
                }

            } else if (props.opcionesRecaudo.agruparFacturas.activo && !props.abonarFactura) {
                return (
                    <div className={"wc"}>
                        {
                            props.facturas.map((fac, key) => {
                                return <Flex className={"px-lg-3 mb-3"} alg="stretch" key={"factura" + key}>
                                    <Flex className={"col-12 col-md-9 contenedorBlanco col-lg-10 py-md-1"} css={Datos}>
                                        <Flex className="col-2 col-md-1" direction={"colunm"}>
                                            <Mycheck
                                                active={props.checks.length > 0 ? props.checks[key] : false}
                                                clickCheck={props.clickCheck.bind(this)} value={key}/>
                                        </Flex>
                                        <Flex className="col-8 col-md-10 ">
                                            <Flex className="col-12">
                                                {fac.map((it, key2) => {
                                                    return (
                                                        <div key={"it" + key2}
                                                             className={`col-12 col-md-${fac.length === 2 ? '6' : '4'} py-2 dato`}>
                                                            <b>{it.titulo}</b>
                                                            <p className={"mb-0 cg description "}>
                                                                {it.valor}
                                                            </p>
                                                        </div>
                                                    )
                                                })}
                                            </Flex>
                                        </Flex>
                                    </Flex>
                                    <div
                                        className="col-12 col-lg-2 pt-2 pt-md-0 px-0 pl-md-3 col-md-3 ml-md-auto mr-md-0 ">
                                        <Btn onClick={() => props.pagar(key)} brdr={"12px"} hg={"100%"}
                                             className={"py-2 py-lg-0 hc"}> PAGAR
                                            FACTURA </Btn>
                                    </div>
                                </Flex>
                            })
                        }
                    </div>
                )
            } else if (!props.opcionesRecaudo.agruparFacturas.activo && props.abonarFactura) {
                return (
                    <div className={"wc"}>
                        {
                            props.facturas.map((fac, key) => {
                                return (<Flex className={"px-lg-3 mb-3"} alg="stretch" key={"factura" + key}>
                                    <Flex className={"col-12 col-md-9 contenedorBlanco col-lg-10 py-md-1"} css={Datos}>
                                        <Flex className="col-12">
                                            {fac.map((it, key2) => {
                                                return (

                                                    <div
                                                        key={"it" + key2}
                                                        className={`col-12 col-md-${fac.length === 2 ? '6' : '4'} py-2 dato`}
                                                    >
                                                        {props.tituloFactura === it.titulo &&
                                                        <div>
                                                            <Mycheck
                                                                abonar={props.abonarFactura}
                                                                active={props.checks.length > 0 ? props.checks[key] : false}
                                                                clickCheck={props.clickCheck.bind(this)} value={key}/>
                                                        </div>
                                                        }
                                                        <b>{it.titulo}</b>
                                                        <p className={"mb-0 cg description "}>
                                                            {it.valor}
                                                        </p>
                                                    </div>
                                                )
                                            })}
                                        </Flex>
                                    </Flex>
                                    <div
                                        className="col-12 col-lg-2 pt-2 pt-md-0 px-0 pl-md-3 col-md-3 ml-md-auto mr-md-0 ">
                                        <Btn onClick={() => props.pagar(key)} brdr={"12px"} hg={"100%"}
                                             className={"py-2 py-lg-0 hc"}> PAGAR
                                            FACTURA </Btn>
                                    </div>
                                </Flex>)
                            })
                        }
                    </div>
                )
            } else if (!props.opcionesRecaudo.agruparFacturas.activo && !props.abonarFactura && props.opcionesRecaudo.modificarValorPagar.activo) {
                return (
                    <Fragment>
                        {props.facturas.map((fac, key) => {
                            return (
                                <Flex className={"px-lg-3 mb-3 wc"} alg="stretch" key={"factura" + key}>
                                    <Flex className={"py-md-1 contenedorBlanco px-0 max-width-100"}
                                          css={Datos}
                                          alg={"stretch"}
                                          elastic={`
                                              1 0 ${(Number(props.opcionesRecadudo.multiplesValoresPago.opcion) * 100 + 500) + "px"}
                                          }`}
                                    >
                                        <Flex className="col-10 col-md-11 px-0 " alg={"stretch"}>


                                            {fac.map((it, key2) => {
                                                if (it.entidad === "facturaId") {
                                                    return (
                                                        <Flex
                                                            key={"it" + key2}
                                                            className={
                                                                props.opcionesRecaudo != "" &&
                                                                props.opcionesRecaudo &&
                                                                (props.opcionesRecadudo.multiplesValoresPago.activo ||
                                                                    props.opcionesRecadudo.fechasVencimiento.activo) ?
                                                                    ` px-0 py-2 dato ` : ` px-0 py-2 dato hc`
                                                            }
                                                            elastic={"1 0 170px"}

                                                        >
                                                            <Flex direction={"colunm"} elastic={"0 0 40px"}>
                                                                <i onClick={() => props.showModal(key)}
                                                                   className={`fa fa-info-circle fa-lg icon-info-circle`}
                                                                />
                                                            </Flex>

                                                            <Flex className={"text-left "} jc={"flex-start"}
                                                                  elastic={"1 0 100px"}>
                                                                {props.tituloFactura === it.titulo &&
                                                                <MyRadio color="primary"
                                                                         name={'MyRadio'}
                                                                         onChange={props.clickCheck.bind(this)}
                                                                         checked={props.checks.length > 0 ? props.checks[key] : false}
                                                                         value={key}
                                                                />
                                                                }
                                                                {/* <Mycheck
                                                                            abonar={props.abonarFactura}
                                                                            active={props.checks.length > 0 ? props.checks[key] : false}
                                                                            clickCheck={props.clickCheck.bind(this)}
                                                                            value={key}/> */}
                                                                <b className="fs-13">{it.titulo}</b>
                                                                <p className={"mb-0 cg description"}>{it.valor}</p>
                                                            </Flex>

                                                        </Flex>
                                                    )
                                                }
                                            })}

                                            <Flex className={`px-0 max-width-100`}
                                                  elastic={`
                                                            1 0 ${
                                                      props.opcionesRecadudo.multiplesValoresPago.opcion === "1" ? "140px" :
                                                          props.opcionesRecadudo.multiplesValoresPago.opcion === "2" ? "240px" :
                                                              props.opcionesRecadudo.multiplesValoresPago.opcion === "3" ? "355px" : ""
                                                  }`}
                                            >
                                                {fac.map((it, key2) => {
                                                    if (
                                                        it.entidad === 'total' ||
                                                        it.entidad === 'segundoTotal' ||
                                                        it.entidad === 'tercerTotal') {

                                                        return (
                                                            <Flex
                                                                key={"it" + key2}
                                                                className={` py-2 py-md-0 px-0 dato-inner text-center`}
                                                                elastic={"1 0 100px"}
                                                            >
                                                                {it.entidad === 'total' &&
                                                                <div className={"wc"}>
                                                                    <MyRadio color="primary"
                                                                             name={'MyRadio'}
                                                                             onChange={props.clickCheckValor1.bind(this)}
                                                                             checked={props[`checksValor1`].length > 0 ? props[`checksValor1`][key] : false}
                                                                             value={key}
                                                                    />
                                                                </div>
                                                                }
                                                                {it.entidad === 'segundoTotal' &&
                                                                <div>
                                                                    <MyRadio color="primary"
                                                                             name={'MyRadio'}
                                                                             onChange={props.clickCheckValor2.bind(this)}
                                                                             checked={props[`checksValor2`].length > 0 ? props[`checksValor2`][key] : false}
                                                                             value={key}
                                                                    />
                                                                </div>
                                                                }
                                                                {it.entidad === 'tercerTotal' &&
                                                                <div>
                                                                    <MyRadio color="primary"
                                                                             name={'MyRadio'}
                                                                             onChange={props.clickCheckValor3.bind(this)}
                                                                             checked={props[`checksValor3`].length > 0 ? props[`checksValor3`][key] : false}
                                                                             value={key}
                                                                    />
                                                                </div>
                                                                }
                                                                <div className="wc">
                                                                    <b className="fs-14">{it.titulo}</b>
                                                                    <p className={"mb-0 cg description "}>
                                                                        {it.valor}
                                                                    </p>
                                                                </div>
                                                            </Flex>
                                                        )
                                                    }
                                                })}
                                            </Flex>

                                            {props.opcionesRecaudo.modificarValorPagar.activo &&

                                            <Flex
                                                className={`${props.opcionesRecadudo.multiplesValoresPago.opcion !== "3" ? "px-2 py-2 py-md-0 pb-md-1 text-center dato " : "lineUp px-2 py-2 py-md-0 pb-md-1 text-center dato "}`}
                                                elastic={"1 0 188px"}
                                            >

                                                <div className={"wc text-center"}>
                                                    <MyRadio color="primary"
                                                             name={props.opcionesRecaudo.modificarValorPagar.activo}
                                                             onChange={props.clickCheckOtroValor.bind(this)}
                                                             checked={props.checksOtroValor.length > 0 ? props.checksOtroValor[key] : false}
                                                             value={key}
                                                    />
                                                </div>
                                                <div className={"wc"}>
                                                    <b className="fs-13">Otro valor </b>
                                                </div>
                                                <MyCampo
                                                    type="mount"
                                                    placeholder={"Otro valor"}
                                                    value={props.valuesOtroValor[key]}
                                                    name={key}
                                                    onChangeValor={props.onChangeOtroValor.bind(this)}
                                                    obligatory={false}
                                                    disabled={!props.checksOtroValor[key]}
                                                    bordeAzul={true}
                                                />
                                            </Flex>
                                            }
                                        </Flex>
                                    </Flex>
                                    <Flex
                                        className="pt-3 pt-xl-0 px-0 pl-lg-3 ml-md-auto mr-md-0 "
                                        elastic={"1 0 90px"}
                                    >
                                        <Btn onClick={() => props.pagar(key)}
                                             brdr={"12px"}
                                             hg={"100%"}
                                             disabled={props.invalidos && props.invalidos[key] === true}
                                             className={"py-2 hc"}
                                        >
                                            PAGAR
                                        </Btn>
                                    </Flex>
                                </Flex>
                            )
                        })}
                    </Fragment>
                )
            }

        } else if (props.opcionesRecaudo != "" && props.opcionesRecaudo && (props.opcionesRecaudo.multiplesValoresPago.activo)) {
            return (
                <Fragment>
                    {props.facturas.map((fac, key) => {
                        return (
                            <Flex className={"px-lg-3 mb-3 wc"} alg="stretch" key={"factura" + key}>
                                <Flex className={"py-md-1 contenedorBlanco px-0"}
                                      css={Datos}
                                      alg={"stretch"}
                                      elastic={`
                                              1 0 ${
                                          props.opcionesRecadudo.multiplesValoresPago.opcion === "1" ? "600px" :
                                              props.opcionesRecadudo.multiplesValoresPago.opcion === "2" ? "700px" :
                                                  props.opcionesRecadudo.multiplesValoresPago.opcion === "3" ? "800px" : ""
                                      }`}
                                >
                                    <Flex className="col-10 col-md-11 px-0 " alg={"stretch"}>


                                        {fac.map((it, key2) => {
                                            if (
                                                it.entidad === "facturaId"
                                            ) {

                                                return (
                                                    <Flex
                                                        key={"it" + key2}
                                                        className={
                                                            props.opcionesRecaudo != "" &&
                                                            props.opcionesRecaudo &&
                                                            (props.opcionesRecadudo.multiplesValoresPago.activo ||
                                                                props.opcionesRecadudo.fechasVencimiento.activo) ?
                                                                ` px-0 py-2 dato ` : ` px-0 py-2 dato hc`
                                                        }
                                                        elastic={"1 0 170px"}

                                                    >
                                                        <Flex direction={"colunm"} elastic={"0 0 40px"}>
                                                            <i onClick={() => props.showModal(key)}
                                                               className={`fa fa-info-circle fa-lg icon-info-circle`}
                                                            />
                                                        </Flex>

                                                        <Flex className={"text-left "} jc={"flex-start"}
                                                              elastic={"1 0 100px"}>
                                                            {props.tituloFactura === it.titulo &&
                                                            <MyRadio color="primary"
                                                                     name={'MyRadio'}
                                                                     onChange={props.clickCheck.bind(this)}
                                                                     checked={props.checks.length > 0 ? props.checks[key] : false}
                                                                     value={key}
                                                            />
                                                            }
                                                            {/* <Mycheck
                                                                            abonar={props.abonarFactura}
                                                                            active={props.checks.length > 0 ? props.checks[key] : false}
                                                                            clickCheck={props.clickCheck.bind(this)}
                                                                            value={key}/> */}
                                                            <b className="fs-13">{it.titulo}</b>
                                                            <p className={"mb-0 cg description"}>{it.valor}</p>
                                                        </Flex>

                                                    </Flex>
                                                )
                                            }
                                        })}

                                        <Flex className={`px-0 max-width-100`}
                                              elastic={`
                                                            1 0 ${
                                                  props.opcionesRecadudo.multiplesValoresPago.opcion === "1" ? "140px" :
                                                      props.opcionesRecadudo.multiplesValoresPago.opcion === "2" ? "240px" :
                                                          props.opcionesRecadudo.multiplesValoresPago.opcion === "3" ? "355px" : ""
                                              }`}
                                        >
                                            {fac.map((it, key2) => {
                                                if (
                                                    it.entidad === 'total' ||
                                                    it.entidad === 'segundoTotal' ||
                                                    it.entidad === 'tercerTotal') {

                                                    return (
                                                        <Flex
                                                            key={"it" + key2}
                                                            className={` py-2 py-md-0 px-0 dato-inner text-center`}
                                                            elastic={"1 0 100px"}
                                                        >
                                                            {it.entidad === 'total' &&
                                                            <div className={"wc"}>
                                                                <MyRadio color="primary"
                                                                         name={'MyRadio'}
                                                                         onChange={props.clickCheckValor1.bind(this)}
                                                                         checked={props[`checksValor1`].length > 0 ? props[`checksValor1`][key] : false}
                                                                         value={key}
                                                                />
                                                            </div>
                                                            }
                                                            {it.entidad === 'segundoTotal' &&
                                                            <div>
                                                                <MyRadio color="primary"
                                                                         name={'MyRadio'}
                                                                         onChange={props.clickCheckValor2.bind(this)}
                                                                         checked={props[`checksValor2`].length > 0 ? props[`checksValor2`][key] : false}
                                                                         value={key}
                                                                />
                                                            </div>
                                                            }
                                                            {it.entidad === 'tercerTotal' &&
                                                            <div>
                                                                <MyRadio color="primary"
                                                                         name={'MyRadio'}
                                                                         onChange={props.clickCheckValor3.bind(this)}
                                                                         checked={props[`checksValor3`].length > 0 ? props[`checksValor3`][key] : false}
                                                                         value={key}
                                                                />
                                                                {/* <Mycheck
                                                                            abonar={props.abonarFactura}
                                                                            active={props[`checksValor3`].length > 0 ? props[`checksValor3`][key] : false}
                                                                            clickCheck={props.clickCheckValor3.bind(this)}
                                                                            value={key}
                                                                        /> */}
                                                            </div>
                                                            }
                                                            <div className="wc">
                                                                <b className="fs-14">{it.titulo}</b>
                                                                <p className={"mb-0 cg description "}>
                                                                    {it.valor}
                                                                    {/*$000.000.00 COP*/}
                                                                </p>
                                                            </div>
                                                        </Flex>
                                                    )
                                                }
                                            })}
                                        </Flex>

                                        {props.opcionesRecaudo.modificarValorPagar.activo &&

                                        <Flex
                                            className={`${props.opcionesRecadudo.multiplesValoresPago.opcion !== "3" ? "px-2 py-2 py-md-0 pb-md-1 text-center dato " : "lineUp px-2 py-2 py-md-0 pb-md-1 text-center dato "}`}
                                            elastic={"1 0 188px"}
                                        >

                                            <div className={"wc text-center"}>
                                                <MyRadio color="primary"
                                                         name={props.opcionesRecaudo.modificarValorPagar.activo}
                                                         onChange={props.clickCheckOtroValor.bind(this)}
                                                         checked={props.checksOtroValor.length > 0 ? props.checksOtroValor[key] : false}
                                                         value={key}
                                                />
                                                {/* <Mycheck
                                                        abonar={props.abonarFactura}
                                                        active={props.checksOtroValor.length > 0 ? props.checksOtroValor[key] : false}
                                                        clickCheck={props.clickCheckOtroValor.bind(this)}
                                                        value={key}/> */}
                                            </div>
                                            <div className={"wc"}>
                                                <b className="fs-13">Otro valor </b>
                                            </div>
                                            <MyCampo
                                                type="mount"
                                                // label={"Otro valor"}
                                                placeholder={"Otro valor"}
                                                value={props.valuesOtroValor[key]}
                                                name={key}
                                                onChangeValor={props.onChangeOtroValor.bind(this)}
                                                obligatory={false}
                                                // configuracionCampos={conf.fieldTypes}
                                                disabled={!props.checksOtroValor[key]}
                                                // error={error}
                                                bordeAzul={true}
                                            />
                                        </Flex>
                                        }
                                    </Flex>
                                </Flex>
                                <Flex
                                    className="pt-3 pt-xl-0 px-0 pl-lg-3 ml-md-auto mr-md-0 "
                                    elastic={"1 0 90px"}
                                >
                                    <Btn onClick={() => props.pagar(key)}
                                         brdr={"12px"}
                                         hg={"100%"}
                                         disabled={props.invalidos && props.invalidos[key] === true}
                                         className={"py-2 hc"}
                                    >
                                        PAGAR
                                    </Btn>
                                </Flex>
                            </Flex>
                        )
                    })}
                </Fragment>
            )
        } else {
            return (
                props.facturas.map((fac, key) => {
                    return (
                        <Flex className={"px-lg-3 mb-3"} alg="stretch" key={"factura" + key}>
                            <Flex className={"col-12 col-md-9 contenedorBlanco col-lg-10 py-md-1"} css={Datos}>
                                <Flex className="col-12">
                                    {fac.map((it, key2) => {
                                        return (

                                            <div key={"it" + key2}
                                                 className={`col-12 col-md-${fac.length === 2 ? '6' : '4'} py-2 dato`}>
                                                <b>{it.titulo}</b>
                                                <p className={"mb-0 cg description "}>
                                                    {it.valor}
                                                </p>
                                            </div>
                                        )
                                    })}
                                </Flex>
                            </Flex>
                            <div className="col-12 col-lg-2 pt-2 pt-md-0 px-0 pl-md-3 col-md-3 ml-md-auto mr-md-0 ">
                                <Btn onClick={() => props.pagar(key)} brdr={"12px"} hg={"100%"}
                                     className={"py-2 py-lg-0 hc"}> PAGAR</Btn>
                            </div>
                        </Flex>
                    )
                })
            )
        }
    }
    return opcionFacturas(data)
};


let ruta = {};

class Listafacturas extends Component {

    constructor(props) {
        super(props);
        this.state = {
            total: 0,
            totalPagar: 0,
            facturas: [],
            loading: false,
            checks: [],
            checksOtroValor: [],
            checksValor1: [],
            checksValor2: [],
            checksValor3: [],
            valuesOtroValor: [],
            allCheck: false,
            agruparFacturas: false,
            paginacion: {},
            pagina: 1,
            hasMoreItems: true,
            moneda: "COP",
            tituloFactura: "",
            abonarFactura: false,
            error: '',
            showMessage: {
                open: false,
                type: 'info',
                isDelay: false,
                message: ''
            },
            showModal: {
                activo: false,
                data: []
            },
            opcionesRecaudo: null,
            cambiarPantalla: false,
            procesando: true,
            invalidos: []
        }
        this.closedAlert = this.closedAlert.bind(this);
        this.showModal = this.showModal.bind(this);
        this.validator = new SimpleReactValidator({
            validators: {
                otroValor: {
                    message: ':attribute',
                    rule: (val) => {},
                }
            }
        })
    }

    setInvalido(key, esInvalido) {
        let invalidos = [...this.state.invalidos];
        invalidos[key] = esInvalido;
        this.setState({ invalidos });
    }

    validarValoresPagar(valor, key) {
        let facturas = [...this.state.facturas];
        let modificarValor = this.state.opcionesRecaudo.modificarValorPagar
        let keyTotal = -1;
        let keySegundoValor = -1;
        let keyTercerValor = -1;
        let aux = 0;
        facturas[0].map((fac, i) => {
            if (fac.entidad === "total") {
                keyTotal = i;
                aux++;
            }
            if (fac.entidad === "segundoTotal") {
                keySegundoValor = i;
                aux++;
            }
            if (fac.entidad === "tercerTotal") {
                keyTercerValor = i;
                aux++;
            }
            return '';
        });

        const marcarInvalido = (msg) => {
            this.setInvalido(key, true);
            this.showAlert('info', false, msg);
        };
        const marcarValido = () => {
            this.setInvalido(key, false);
            this.closedAlert();
        };

        if (parseInt(valor) <= 0) {
            marcarInvalido('El valor debe ser mayor que cero (0)');
            return;
        }
        if (modificarValor.activo) {
            if (aux > 1) {

                let valores = [];
                let valoresMoneda = [];
                facturas[key].filter((infoFac) => {
                    if (infoFac.entidad === "total" || infoFac.entidad === "segundoTotal" || infoFac.entidad === "tercerTotal") {
                        valores.push(infoFac.valor2);
                        valoresMoneda.push(infoFac.valor);
                    }
                })

                let valorMaximo = valores[0];
                let valorMaximoMoneda = valoresMoneda[0];
                let valorMinimo = valores[0];
                for (let i = 1; i < valores.length; i++) {
                    if (valores[i]) {
                        if (valorMaximo < valores[i]) {
                            valorMaximo = valores[i];
                            valorMaximoMoneda = valoresMoneda[i];
                        }
                        if (valorMinimo > valores[i]) {
                            valorMinimo = valores[i];
                        }
                    }
                }
                if (this.state.opcionesRecaudo.modificarValorPagar.opcion === "<" && valor > valorMaximo) {
                    marcarInvalido(`Supera el valor máximo (${valorMaximoMoneda}) permitido a pagar de la factura`);
                } else {
                    marcarValido();
                }
            } else {
                switch (modificarValor.opcion) {
                    case '<':
                        if (
                            parseInt(valor) > (keyTercerValor !== -1
                            ? parseInt(facturas[key][keyTercerValor].valor2)
                            : (keySegundoValor !== -1
                                    ? parseInt(facturas[key][keySegundoValor].valor2)
                                    : parseInt(facturas[key][keyTotal].valor2)
                            ))
                            || parseInt(valor) <= 0) {
                            marcarInvalido('Solo están permitidos valores inferiores al valor inicial.');
                        } else {
                            marcarValido();
                        }
                        break;
                    case '>':
                        if (parseInt(valor) < (keyTercerValor !== -1
                            ? parseInt(facturas[key][keyTercerValor].valor2)
                            : (keySegundoValor !== -1
                                    ? parseInt(facturas[key][keySegundoValor].valor2)
                                    : parseInt(facturas[key][keyTotal].valor2)
                            ))
                            || parseInt(valor) <= 0) {
                            marcarInvalido('Solo están permitidos valores superiores al valor inicial.');
                        } else {
                            marcarValido();
                        }
                        break;
                    default:
                        marcarValido();
                }
            }
        }

    }



    showAlert(type = 'info', isDelay = false, message = '') {
        this.setState({
            showMessage: {
                open: true,
                type: type,
                isDelay: isDelay,
                message: message
            }
        }, () => {
            if (isDelay) {
                setTimeout(function () {
                    this.setState({
                        showMessage: {
                            open: false,
                            type: 'info',
                            isDelay: false,
                            message: ''
                        },
                    })
                }, 5000);
            }
        })
    }

    closedAlert() {
        this.setState({
            showMessage: {
                open: false,
                type: 'info',
                isDelay: false,
                message: ''
            },
        })
    }

    componentDidMount() {

        ruta = JSON.parse(sessionStorage.getItem("rutas"));

        // his.request();
        this.verData();
        if (sessionStorage.getItem('opcionesRecaudo')) {
            let opcionRecaudo = sessionStorage.getItem('opcionesRecaudo')
            this.setState({
                opcionesRecaudo: JSON.parse(opcionRecaudo),
            })
        }
    }

    verData() {
        let facturas = JSON.parse(sessionStorage.getItem("facturas"));
        let configCampos = JSON.parse(sessionStorage.getItem("configCampos"));
        let Total = sessionStorage.getItem("total");
        let paginacion = JSON.parse(sessionStorage.getItem("paginacion"));


        let moneda = "";
        let check = [];
        let checksOtroValor = [];
        let checksValor1 = [];
        let checksValor2 = [];
        let checksValor3 = [];
        let valuesOtroValor = [];
        let session = false;
        if (sessionStorage.getItem("check")) {
            check = JSON.parse(sessionStorage.getItem("check"));
            checksOtroValor = JSON.parse(sessionStorage.getItem("checksOtroValor"));
            checksValor1 = JSON.parse(sessionStorage.getItem("checksValor1"));
            checksValor2 = JSON.parse(sessionStorage.getItem("checksValor2"));
            checksValor3 = JSON.parse(sessionStorage.getItem("checksValor3"));
            valuesOtroValor = JSON.parse(sessionStorage.getItem("valuesOtroValor"));
            check.forEach((c) => {
                if (c) session = true;
            })
        }

        let tituloFactura = "";
        let opcionesRecaudo = JSON.parse(sessionStorage.getItem('opcionesRecaudo')) || this.state.opcionesRecaudo

        if (facturas && facturas.length > 0) {
            let newFacturas = [];
            facturas.map((fac) => {
                if (!session) {
                    check.push(false);
                    checksOtroValor.push(false);
                    checksValor1.push(false);
                    checksValor2.push(false);
                    checksValor3.push(false);
                    valuesOtroValor.push(0);
                }
                let config = [];
                configCampos.map((conf) => {
                    let data = {};
                    let numeroFactura = false;
                    Object.keys(fac).filter(k => {
                        if (opcionesRecaudo && opcionesRecaudo.modificarValorPagar && !opcionesRecaudo.modificarValorPagar.activo) {
                            if (k === conf.entidad && (conf.entidad === "facturaId" || conf.entidad === "total" || conf.entidad === "fechaExpiracion" || conf.entidad === "segundaFechaVencimiento" || conf.entidad === "terceraFechaVencimiento" || conf.entidad === "segundoTotal" || conf.entidad === "tercerTotal" || conf.entidad === "iva") && conf.visible) {

                                data["titulo"] = conf.titulo_campo;
                                data['entidad'] = conf.entidad;
                                if (conf.entidad === "total" || conf.entidad === "segundoTotal" || conf.entidad === "tercerTotal") {
                                    data['entidad'] = conf.entidad;
                                    data["valor"] = `$${parseFloat(fac[k]).toLocaleString('en-US', {minimumFractionDigits: 0})} ${fac["moneda"]}`;
                                    data["valor2"] = parseFloat(fac[k]);
                                    moneda = `${fac["moneda"]}`;
                                    if (conf.entidad === "total") {
                                        tituloFactura = conf.titulo_campo;
                                        numeroFactura = true;
                                    }
                                } else {
                                    if (conf.entidad === "facturaId") {
                                        numeroFactura = true;
                                    }
                                    data["valor"] = fac[k];
                                }
                            }
                        }
                        else {
                            if (k === conf.entidad && (conf.entidad === "facturaId" || conf.entidad === "total" || conf.entidad === "fechaExpiracion" || conf.entidad === "segundaFechaVencimiento" || conf.entidad === "terceraFechaVencimiento" || conf.entidad === "segundoTotal" || conf.entidad === "tercerTotal" || conf.entidad === "iva") && conf.visible) {
                                data["titulo"] = conf.titulo_campo;
                                data['entidad'] = conf.entidad
                                if (conf.entidad === "total" || conf.entidad === "segundoTotal" || conf.entidad === "tercerTotal") {
                                    data["valor"] = `$${parseFloat(fac[k]).toLocaleString('en-US', {minimumFractionDigits: 0})} ${fac["moneda"]}`;
                                    data["valor2"] = parseFloat(fac[k]);
                                    data['entidad'] = conf.entidad
                                    moneda = `${fac["moneda"]}`;
                                    if (conf.entidad === "total") {
                                        data["opcion"] = 1;
                                        tituloFactura = conf.titulo_campo;
                                        numeroFactura = true;
                                    }
                                } else {
                                    if (conf.entidad === "facturaId") {
                                        numeroFactura = true;
                                    }
                                    data["valor"] = fac[k];
                                }

                            }
                        }
                        if (opcionesRecaudo !== "" && opcionesRecaudo && opcionesRecaudo.multiplesValoresPago.activo) {
                            if (k === conf.entidad && (conf.entidad === "facturaId" || conf.entidad === "total" || conf.entidad === "fechaExpiracion" || conf.entidad === "segundaFechaVencimiento" || conf.entidad === "terceraFechaVencimiento" || conf.entidad === "segundoTotal" || conf.entidad === "tercerTotal" || conf.entidad === "iva") && conf.visible) {
                                data["titulo"] = conf.titulo_campo;
                                data['entidad'] = conf.entidad
                                if (conf.entidad === "total" || conf.entidad === "segundoTotal" || conf.entidad === "tercerTotal") {
                                    data["valor"] = `$${parseFloat(fac[k]).toLocaleString('en-US', {minimumFractionDigits: 0})} ${fac["moneda"]}`;
                                    data["valor2"] = parseFloat(fac[k]);
                                    data['entidad'] = conf.entidad
                                    if (conf.entidad === 'segundoTotal') {
                                        data['opcion'] = 2
                                    } else if (conf.entidad === 'tercerTotal') {
                                        data['opcion'] = 3
                                    }

                                    moneda = `${fac["moneda"]}`;
                                    if (conf.entidad === "total") {
                                        tituloFactura = conf.titulo_campo;
                                        numeroFactura = true;
                                    }
                                } else {
                                    if (conf.entidad === "facturaId") {
                                        numeroFactura = true;
                                    }
                                    data["valor"] = fac[k];
                                }

                            }
                        }
                        return ''
                    });
                    if (numeroFactura) {
                        config.unshift(data);
                    } else {
                        config.push(data);
                    }

                    return  '';
                });
                newFacturas.push(config)

            });

            let filtered = [];
            newFacturas.filter((fac) => {
                let data = fac.filter((camp) => {
                    return Object.keys(camp).length > 0;
                });
                filtered.push(data);
                return ''
            });

            sessionStorage.setItem("check", JSON.stringify((check)));
            sessionStorage.setItem("checksOtroValor", JSON.stringify((checksOtroValor)));
            sessionStorage.setItem("checksValor1", JSON.stringify((checksValor1)));
            sessionStorage.setItem("checksValor2", JSON.stringify((checksValor2)));
            sessionStorage.setItem("checksValor3", JSON.stringify((checksValor3)));
            sessionStorage.setItem("valuesOtroValor", JSON.stringify((valuesOtroValor)));


            let allCheck = true;
            check.forEach((c) => {
                if (!c) allCheck = false
            })
            this.setState({
                allCheck: allCheck,
                facturas: filtered,
                configCampos,
                total:Total,
                checks: check,
                checksOtroValor: checksOtroValor,
                checksValor1: checksValor1,
                checksValor2: checksValor2,
                checksValor3: checksValor3,
                valuesOtroValor: valuesOtroValor,
                paginacion,
                hasMoreItems: paginacion.to < paginacion.total,
                moneda,
                tituloFactura,
                procesando: false
            }, () => this.valorTotal());
        }
        else {
            // alert("No existen facturas");
            this.props.openModal("No se encontraron facturas.", "danger")
            this.props.history.push(ruta.home);
        }
    }

    pagar(key) {
        let opcionesRecaudo = this.state.opcionesRecadudo || JSON.parse(sessionStorage.getItem('opcionesRecaudo'))
        sessionStorage.setItem("facturaPagar", key);
        sessionStorage.setItem("check", JSON.stringify((this.state.checks)));
        sessionStorage.setItem("checksOtroValor", JSON.stringify((this.state.checksOtroValor)));
        sessionStorage.setItem("checksValor1", JSON.stringify((this.state.checksValor1)));
        sessionStorage.setItem("checksValor2", JSON.stringify((this.state.checksValor2)));
        sessionStorage.setItem("checksValor3", JSON.stringify((this.state.checksValor3)));
        sessionStorage.setItem("valuesOtroValor", JSON.stringify((this.state.valuesOtroValor)));
        let activo = true

        if (opcionesRecaudo != "" && opcionesRecaudo && opcionesRecaudo.multiplesValoresPago.activo) {
            activo = false
            this.state.checks.map((item) => {
                if (item) {
                    activo = true
                }
            })

            if (!activo) {
                this.state.checksValor1.map((item) => {
                    if (item) {
                        activo = true
                    }
                })
            }

            if (!activo) {
                this.state.checksValor2.map((item) => {
                    if (item) {
                        activo = true
                    }
                })
            }

            if (!activo) {
                this.state.checksValor3.map((item) => {
                    if (item) {
                        activo = true
                    }
                })
            }

            let stop = false;
            this.state.checksOtroValor.map((item, k) => {
                if (item) {
                    if (this.state.valuesOtroValor[k] <= 0 && key === k) {
                        this.showAlert('info', false, 'El valor debe ser mayor que cero (0)')
                        stop = true;
                    } else {
                        activo = true
                    }
                }
            })
            if (stop) return;

            if (!activo) {
                toast.warning('Debe seleccionar por lo menos un valor para realizar el pago')
            }
        }

        if (this.state.checksOtroValor[key]) {
            if (activo) {
                let modificarValor = this.state.opcionesRecaudo.modificarValorPagar
                if (modificarValor && modificarValor.activo) {
                    let facturas = [...this.state.facturas]
                    let keyTotal = -1;
                    let keySegundoValor = -1;
                    let keyTercerValor = -1;
                    let aux = 0;

                    let valor = this.state.valuesOtroValor[key];
                    facturas[0].map((fac, i) => {
                        if (fac.entidad === "total") {
                            keyTotal = i;
                            aux++;
                        }
                        if (fac.entidad === "segundoTotal") {
                            keySegundoValor = i;
                            aux++;
                        }
                        if (fac.entidad === "tercerTotal") {
                            keyTercerValor = i;
                            aux++;
                        }
                    });
                    if (aux > 1) {
                        let valores = [];
                        let valoresMoneda = [];
                        facturas[key].filter((infoFac) => {
                            if (infoFac.entidad === "total" || infoFac.entidad === "segundoTotal" || infoFac.entidad === "tercerTotal") {
                                valores.push(infoFac.valor2);
                                valoresMoneda.push(infoFac.valor);
                            }
                            // if (infoFac.entidad === "total") {
                            // valorComparacionMinimo = infoFac.valorReal;
                            // }
                        })

                        let valorMaximo = valores[0];
                        let valorMaximoMoneda = valoresMoneda[0];
                        let valorMinimo = valores[0];
                        // let valorMinimoMoneda = valoresMoneda[0];
                        for (let i = 1; i < valores.length; i++) {
                            if (valores[i]) {
                                if (valorMaximo < valores[i]) {
                                    valorMaximo = valores[i];
                                    valorMaximoMoneda = valoresMoneda[i];
                                }

                                if (valorMinimo > valores[i]) {
                                    valorMinimo = valores[i];
                                    // valorMinimoMoneda = valoresMoneda[i];
                                }
                            }
                        }
                        if (this.state.opcionesRecaudo.modificarValorPagar.opcion === "<" && valor > valorMaximo) {
                            this.showAlert('info', false, `Supera el valor máximo (${valorMaximoMoneda}) permitido a pagar de la factura`)
                        } else if (this.state.opcionesRecaudo.modificarValorPagar.opcion === ">" && valor < valorMaximo) {
                            this.showAlert('info', false, `Supera el valor mínimo (${valorMaximoMoneda}) permitido a pagar de la factura`)
                        } else {
                            this.closedAlert()
                            this.props.history.push({
                                pathname: ruta.factura,
                                isSuscrito: this.props.location.isSuscrito || false,
                            });
                        }


                    } else {
                        switch (modificarValor.opcion) {
                            case '<':
                                if (
                                    parseInt(valor) > (keyTercerValor !== -1
                                    ? parseInt(facturas[key][keyTercerValor].valor2)
                                    : (keySegundoValor !== -1
                                            ? parseInt(facturas[key][keySegundoValor].valor2)
                                            : parseInt(facturas[key][keyTotal].valor2)
                                    ))
                                    || parseInt(valor) <= 0) {
                                    this.showAlert('info', false, 'Solo estan permitidos valores inferiores al valor inicial')
                                } else {
                                    this.closedAlert()
                                    this.props.history.push({pathname: ruta.factura, isSuscrito: this.props.location.isSuscrito || false });
                                }
                                break;
                            case '>':
                                if (parseInt(valor) < (keyTercerValor !== -1
                                    ? parseInt(facturas[key][keyTercerValor].valor2)
                                    : (keySegundoValor !== -1
                                            ? parseInt(facturas[key][keySegundoValor].valor2)
                                            : parseInt(facturas[key][keyTotal].valor2)
                                    ))
                                    || parseInt(valor) <= 0) {
                                    this.showAlert('info', false, 'Solo estan permitidos valores superiores al valor inicial')
                                } else {
                                    this.closedAlert()
                                    this.props.history.push({pathname: ruta.factura, isSuscrito: this.props.location.isSuscrito || false });
                                }
                                break;
                            default:
                                this.props.history.push({pathname: ruta.factura, isSuscrito: this.props.location.isSuscrito || false });
                                this.closedAlert()
                        }
                    }
                } else {
                    this.props.history.push({pathname: ruta.factura, isSuscrito: this.props.location.isSuscrito || false });
                }
            }
        } else if (activo) {
            this.props.history.push({pathname: ruta.factura, isSuscrito: this.props.location.isSuscrito || false });
        }


    }


    onChangeCheck(key, all = false) {
        let checks = [...this.state.checks];
        let checksOtroValor = [...this.state.checksOtroValor];
        let checksValor1 = [...this.state.checksValor1];
        let checksValor2 = [...this.state.checksValor2];
        let checksValor3 = [...this.state.checksValor3];

        let allCheckState = this.state.allCheck;
        let totalPagar = this.state.totalPagar;
        let configCampos = JSON.parse(sessionStorage.getItem("configCampos"));
        if (all) {

            let allCheck = checks.map((al, k) => {
                let aux = 0;
                if (allCheckState) {
                    all = false;
                    checksOtroValor[k] = false;
                    checksValor1[k] = false;
                    checksValor2[k] = false;
                    checksValor3[k] = false;
                    totalPagar = 0;
                    return false
                } else {
                    all = true;
                    if (!checksOtroValor[k] && !checksValor1[k] && !checksValor2[k] && !checksValor3[k]) {
                        while ((!checksValor1[k] && !checksValor2[k] && !checksValor3[k]) || aux === 3) {
                            aux++;
                            configCampos.map((cc) => {
                                if (cc.entidad === "total" && cc.visible && aux === 1) {
                                    checksValor1[k] = true;
                                } else if (cc.entidad === "segundoTotal" && cc.visible && !checksValor1[k] && aux === 2) {
                                    checksValor2[k] = true;
                                } else if (cc.entidad === "tercerTotal" && cc.visible && !checksValor1[k] && !checksValor2[k] && aux === 3) {
                                    checksValor3[k] = true;
                                }
                            })
                        }
                    }

                    return true;
                }
            });

            checks = allCheck;
        } else {
            checks[key] = !checks[key];
            if (checks[key]) {
                let Aux = 0;
                while ((!checksValor1[key] && !checksValor2[key] && !checksValor3[key]) || Aux === 3) {
                    Aux++;
                    configCampos.map((cc) => {
                        if (cc.entidad === "total" && cc.visible && Aux === 1) {
                            checksValor1[key] = true;
                        } else if (cc.entidad === "segundoTotal" && cc.visible && !checksValor1[key] && Aux === 2) {
                            checksValor2[key] = true;
                        } else if (cc.entidad === "tercerTotal" && cc.visible && !checksValor1[key] && !checksValor2[key] && Aux === 3) {
                            checksValor3[key] = true;
                        }
                    })
                }

            } else {
                checksOtroValor[key] = false;
                checksValor1[key] = false;
                checksValor2[key] = false;
                checksValor3[key] = false;
            }

            if (checks[key] === false) all = false;
            let aux = false;
            checks.map((it, i) => {
                if (it === false) {
                    all = false;
                    aux = true;
                } else if (i === checks.length - 1 && it && !aux) {
                    all = true;
                }
                return '';
            })
        }

        let tieneAgrupacion = this.state.opcionesRecaudo && this.state.opcionesRecaudo != "" && this.state.opcionesRecaudo.agruparFacturas.activo;

        if (!tieneAgrupacion) {
            checks.map((ch, i) => {
                checks[i] = false;
                return '';
            });
        }
        this.setState({
            checks,
            allCheck: all,
            totalPagar,
            checksOtroValor,
            checksValor1,
            checksValor2,
            checksValor3,
        }, () => this.valorTotal())
    }

    pagarFacturas() {
        let facturaPagar = [];
        this.state.checks.map((it, key) => {
            if (it && key < this.state.facturas.length) {
                facturaPagar.push(key);
            }
        })
        let facturas = [...this.state.facturas]
        let modificarValor = this.state.opcionesRecaudo.modificarValorPagar
        let error = false;
        if (this.state.checksOtroValor && this.state.checksOtroValor.length >= facturaPagar.length) {
            facturaPagar.forEach((fact) => {
                if (this.state.checksOtroValor[fact] && this.state.valuesOtroValor[fact] <= 0) this.showAlert('info', false, 'El valor debe ser mayor que cero (0)')
                else {
                    let keyTotal = -1;
                    let keySegundoValor = -1;
                    let keyTercerValor = -1;
                    let aux = 0;
                    let key = fact;
                    let valor = this.state.valuesOtroValor[fact];
                    facturas[fact].map((fac, i) => {
                        if (fac.entidad === "total") {
                            keyTotal = i;
                            aux++;
                        }
                        if (fac.entidad === "segundoTotal") {
                            keySegundoValor = i;
                            aux++;
                        }
                        if (fac.entidad === "tercerTotal") {
                            keyTercerValor = i;
                            aux++;
                        }
                    });
                    if (modificarValor.activo && !error && this.state.checksOtroValor[fact]) {
                        if (aux > 1) {
                            let valores = [];
                            let valoresMoneda = [];
                            facturas[key].filter((infoFac) => {
                                if (infoFac.entidad === "total" || infoFac.entidad === "segundoTotal" || infoFac.entidad === "tercerTotal") {
                                    valores.push(infoFac.valor2);
                                    valoresMoneda.push(infoFac.valor);
                                }
                            });


                            let valorMaximo = valores[0];
                            let valorMaximoMoneda = valoresMoneda[0];
                            let valorMinimo = valores[0];
                            // let valorMinimoMoneda = valoresMoneda[0];
                            for (let i = 1; i < valores.length; i++) {
                                if (valores[i]) {
                                    if (valorMaximo < valores[i]) {
                                        valorMaximo = valores[i];
                                        valorMaximoMoneda = valoresMoneda[i];
                                    }

                                    if (valorMinimo > valores[i]) {
                                        valorMinimo = valores[i];
                                        // valorMinimoMoneda = valoresMoneda[i];
                                    }
                                }
                            }
                            if (this.state.opcionesRecaudo.modificarValorPagar.opcion === "<" && valor > valorMaximo) {
                                this.showAlert('info', false, `Supera el valor máximo (${valorMaximoMoneda}) permitido a pagar de la factura ${fact + 1}`)
                                error = true;
                            } else if (this.state.opcionesRecaudo.modificarValorPagar.opcion === ">" && valor < valorMaximo) {
                                this.showAlert('info', false, `No supera el valor mínimo (${valorMaximoMoneda}) permitido a pagar de la factura ${fact + 1}`
                                );
                                error = true;
                            } else {
                                this.closedAlert()
                            }
                        } else {
                            switch (modificarValor.opcion) {
                                case '<':
                                    if (
                                        parseInt(valor) > (keyTercerValor !== -1
                                        ? parseInt(facturas[key][keyTercerValor].valor2)
                                        : (keySegundoValor !== -1
                                                ? parseInt(facturas[key][keySegundoValor].valor2)
                                                : parseInt(facturas[key][keyTotal].valor2)
                                        ))
                                        || parseInt(valor) <= 0) {
                                        error = true;
                                        this.showAlert('info', false, `Solo están permitidos valores inferiores al valor inicial en el comprobante #${fact + 1}`)
                                    } else {
                                        this.closedAlert()
                                    }
                                    break;
                                case '>':
                                    if (parseInt(valor) < (keyTercerValor !== -1
                                        ? parseInt(facturas[key][keyTercerValor].valor2)
                                        : (keySegundoValor !== -1
                                                ? parseInt(facturas[key][keySegundoValor].valor2)
                                                : parseInt(facturas[key][keyTotal].valor2)
                                        ))
                                        || parseInt(valor) <= 0) {
                                        error = true;
                                        this.showAlert('info', false, `Solo estan permitidos valores superiores al valor inicial en el comprobante #${fact + 1}`)
                                    } else {
                                        this.closedAlert()
                                    }
                                    break;
                            }
                        }
                    }
                }
            })
        }

        if (!error) {
            sessionStorage.setItem("check", JSON.stringify((this.state.checks)));
            sessionStorage.setItem("checksOtroValor", JSON.stringify((this.state.checksOtroValor)));
            sessionStorage.setItem("checksValor1", JSON.stringify((this.state.checksValor1)));
            sessionStorage.setItem("checksValor2", JSON.stringify((this.state.checksValor2)));
            sessionStorage.setItem("checksValor3", JSON.stringify((this.state.checksValor3)));
            sessionStorage.setItem("valuesOtroValor", JSON.stringify((this.state.valuesOtroValor)));
            sessionStorage.setItem("facturaPagar", JSON.stringify(facturaPagar));
            this.props.history.push({pathname: ruta.factura, isSuscrito: this.props.location.isSuscrito || false })
        }

    }

    loadFunc(page) {
        // this.buscarFactura();
    }

    buscarFactura() {
        this.setState({
            loading: true,
        });
        // sessionStorage.removeItem("total");
        // sessionStorage.removeItem("facturas");
        // sessionStorage.removeItem("paginacion");
        let param = JSON.parse(sessionStorage.getItem("param"));
        let pagina = this.state.pagina;
        let data = {
            "referencia": param.referencia,
            "band": "r",
            "option": param.optionDb
        };
        serviceApiResponse(data, `${api.facturas}?page=${pagina + 1}`, "POST")
            .then((response) => {
                if (response.success) {

                    this.setState({
                        loading: false,
                        data: response.data,
                    }, () => {
                        let facturas = JSON.parse(sessionStorage.getItem("facturas"));
                        response.data.facturas.forEach((f) => {
                            facturas.push(f);
                        });
                        let Total = sessionStorage.getItem("total");
                        sessionStorage.setItem("facturas", JSON.stringify(facturas));
                        // sessionStorage.setItem("configCampos", JSON.stringify(response.data.configCampos));
                        sessionStorage.setItem("total", JSON.stringify(parseFloat(Total) + parseFloat(response.data.total)));
                        sessionStorage.setItem("paginacion", JSON.stringify(response.data.paginacionFacturas));
                        this.verData();

                    })
                } else {
                    this.setState({
                        loading: false,
                    });
                    this.props.openModal("Ocurrió un error al consultar la factura, por favor intente más tarde", "success");
                }
            })
            .catch((error) => {
                this.setState({
                    loading: false,
                })
            })
    }

    valorTotal() {
        let checks = [...this.state.checks];
        let checksOtroValor = [...this.state.checksOtroValor];
        let checksValor1 = [...this.state.checksValor1];
        let checksValor2 = [...this.state.checksValor2];
        let checksValor3 = [...this.state.checksValor3];
        let valuesOtroValor = [...this.state.valuesOtroValor];
        let facturas = [...this.state.facturas];
        let totalPagar = 0;
        let opcionesRecaudo = this.state.opcionesRecadudo || JSON.parse(sessionStorage.getItem('opcionesRecaudo'))
        //Validar multiples valores para pago
        if (opcionesRecaudo != "" && opcionesRecaudo && (opcionesRecaudo.multiplesValoresPago.activo || opcionesRecaudo.fechasVencimiento.activo || opcionesRecaudo.agruparFacturas)) {
            totalPagar = 0
            checks.map((checked, key) => {
                if (checked) {
                    if (checksOtroValor[key]) {
                        totalPagar += valuesOtroValor[key];
                    } else {
                        let factura = facturas[key]
                        if (checksValor1[key] && factura) {
                            totalPagar += factura.filter(f => f.entidad === 'total')[0].valor2;
                        } else if (checksValor2[key] && factura) {
                            totalPagar += factura.filter(f => f.entidad === 'segundoTotal')[0].valor2;
                        } else if (checksValor3[key] && factura) {
                            totalPagar += factura.filter(f => f.entidad === 'tercerTotal')[0].valor2;
                        }
                    }

                }
                return '';
            })

        }
        this.setState({
            totalPagar,
            total: totalPagar
        })
        sessionStorage.setItem("total", totalPagar);
    }

    onChangeOtroValor(valor, key) {

        let checks = [...this.state.checks];
        let checksOtroValor = [...this.state.checksOtroValor];
        let checksValor1 = [...this.state.checksValor1];
        let checksValor2 = [...this.state.checksValor2];
        let checksValor3 = [...this.state.checksValor3];
        let valuesOtroValor = [...this.state.valuesOtroValor];

        checksOtroValor[key] = true;
        checks[key] = true;
        checksValor1[key] = false;
        checksValor2[key] = false;
        checksValor3[key] = false;
        // valuesOtroValor[key]= valor;
        //Validar el otro valor ingresado con las reglas configuradas en el proyecto de recaudo
        let configuracion = JSON.parse(sessionStorage.getItem("configuracion"));

        if(configuracion){
            let busquedas = configuracion.busqueda;
            if(busquedas){
                let search = busquedas.find(val => !!val.decimal);
                if(search && valor){
                    if(search.decimal != ""){
                        valuesOtroValor[key] = Number(valor.replace(/[^0-9.]+/g,""));
                    }else{
                        valuesOtroValor[key] = Number(valor.replace(/[^0-9]+/g,""));
                    }
                }else{
                    valuesOtroValor[key] = Number(String(valor).replace(/[^0-9]+/g,""));
                }
            }
        }
        if (parseInt(valor) < 1) {
            // toast.error('Debe ingresar un valor igual o superior a un $(1) peso')
        }
        let allCheck = true;
        checks.forEach((c) => {
            if (!c) allCheck = false
        })

        let tieneAgrupacion = this.state.opcionesRecaudo && this.state.opcionesRecaudo != "" && this.state.opcionesRecaudo.agruparFacturas.activo;
        if (!tieneAgrupacion) {
            checks.map((ch, i) => {
                checks[i] = false;
                return '';
            });
        }
        this.setState({
            allCheck: allCheck,
            checks,
            checksOtroValor,
            checksValor1,
            checksValor2,
            checksValor3,
            valuesOtroValor,
        }, () => {
            this.valorTotal();
            this.validarValoresPagar(valor, key);
            this.validator.showMessages();
        })

    }

    cambiarPantalla() {
        if (this.state.opcionesRecaudo && this.state.opcionesRecaudo.agruparFacturas.activo) {
            this.setState({
                cambiarPantalla: true
            })
        }
    }

    salirCambiarPantalla() {
        this.setState({
            cambiarPantalla: false
        })
    }

    clickCheckOtroValor(e) {
        let key = e.target.value
        let checks = [...this.state.checks];
        let checksOtroValor = [...this.state.checksOtroValor];
        let checksValor1 = [...this.state.checksValor1];
        let checksValor2 = [...this.state.checksValor2];
        let checksValor3 = [...this.state.checksValor3];
        checksOtroValor[key] = !checksOtroValor[key];
        if (checksOtroValor[key]) {
            checks[key] = true;
            checksValor1[key] = false;
            checksValor2[key] = false;
            checksValor3[key] = false;
        } else {
            checks[key] = false;
        }

        let allCheck = true;
        checks.forEach((c) => {
            if (!c) allCheck = false
        })
        let tieneAgrupacion = this.state.opcionesRecaudo && this.state.opcionesRecaudo != "" && this.state.opcionesRecaudo.agruparFacturas.activo;
        if (!tieneAgrupacion) {
            checks.map((ch, i) => {
                checks[i] = false;
                return '';
            });
        }
        this.setState({
            allCheck: allCheck,
            checks,
            checksOtroValor,
            checksValor1,
            checksValor2,
            checksValor3,
        }, () => {
            this.valorTotal();
            if (!this.state.cambiarPantalla && checksOtroValor[key]) this.cambiarPantalla();

        });
    }

    clickCheckValor1(e) {
        let key = e.target.value
        let checks = [...this.state.checks];
        let checksOtroValor = [...this.state.checksOtroValor];
        let checksValor1 = [...this.state.checksValor1];
        let checksValor2 = [...this.state.checksValor2];
        let checksValor3 = [...this.state.checksValor3];
        checksValor1[key] = !checksValor1[key];
        if (checksValor1[key]) {
            checks[key] = true;
            checksOtroValor[key] = false;
            checksValor2[key] = false;
            checksValor3[key] = false;
        } else {
            checks[key] = false;
        }
        let allCheck = true;
        checks.forEach((c) => {
            if (!c) allCheck = false
        });
        let tieneAgrupacion = this.state.opcionesRecaudo && this.state.opcionesRecaudo != "" && this.state.opcionesRecaudo.agruparFacturas.activo;
        if (!tieneAgrupacion) {
            checks.map((ch, i) => {
                checks[i] = false;
                return '';
            });
        }
        this.setState({
            allCheck: allCheck,
            checks,
            checksOtroValor,
            checksValor1,
            checksValor2,
            checksValor3,
        }, () => this.valorTotal())
    }

    clickCheckValor2(e) {
        let key = e.target.value
        let checks = [...this.state.checks];
        let checksOtroValor = [...this.state.checksOtroValor];
        let checksValor1 = [...this.state.checksValor1];
        let checksValor2 = [...this.state.checksValor2];
        let checksValor3 = [...this.state.checksValor3];
        checksValor2[key] = !checksValor2[key];
        if (checksValor2[key]) {
            checks[key] = true;
            checksValor1[key] = false;
            checksOtroValor[key] = false;
            checksValor3[key] = false;
        } else {
            checks[key] = false;
        }
        let allCheck = true;
        checks.forEach((c) => {
            if (!c) allCheck = false
        })
        let tieneAgrupacion = this.state.opcionesRecaudo && this.state.opcionesRecaudo != "" && this.state.opcionesRecaudo.agruparFacturas.activo;
        if (!tieneAgrupacion) {
            checks.map((ch, i) => {
                checks[i] = false;
                return '';
            });
        }
        this.setState({
            allCheck: allCheck,
            checks,
            checksOtroValor,
            checksValor1,
            checksValor2,
            checksValor3,
        }, () => this.valorTotal())
    }

    clickCheckValor3(e) {
        let key = e.target.value
        let checks = [...this.state.checks];
        let checksOtroValor = [...this.state.checksOtroValor];
        let checksValor1 = [...this.state.checksValor1];
        let checksValor2 = [...this.state.checksValor2];
        let checksValor3 = [...this.state.checksValor3];
        checksValor3[key] = !checksValor3[key];
        if (checksValor3[key]) {
            checks[key] = true;
            checksValor1[key] = false;
            checksValor2[key] = false;
            checksOtroValor[key] = false;
        } else {
            checks[key] = false;
        }
        let allCheck = true;
        checks.forEach((c) => {
            if (!c) allCheck = false
        })
        let tieneAgrupacion = this.state.opcionesRecaudo && this.state.opcionesRecaudo != "" && this.state.opcionesRecaudo.agruparFacturas.activo;
        if (!tieneAgrupacion) {
            checks.map((ch, i) => {
                checks[i] = false;
                return '';
            });
        }
        this.setState({
            allCheck: allCheck,
            checks,
            checksOtroValor,
            checksValor1,
            checksValor2,
            checksValor3,
        }, () => this.valorTotal())
    }

    showModal(key = null) {
        let facturas = JSON.parse(sessionStorage.getItem('facturas'));
        let factura = key != null ? facturas[key] : null;
        let campos = [...this.state.configCampos];
        let data = [];
        if (factura) {
            Object.entries(factura).forEach(([i, value]) => {
                if (value != null) {
                    let config = campos.filter(f => f.entidad === i)[0]
                    if (config && config.visible) {
                        data.push({'llave': config.titulo_campo, 'valor': value, 'entidad': config.entidad})
                    }
                }
            });
        }
        this.setState({
            showModal: {
                activo: !this.state.showModal.activo,
                data: data.reverse()
            }
        })
    }

    render() {
        let facturaSeleccionada = this.state.checks.filter((it) => {
            return it === true;
        });



        return (
            <Elastic
                felx={"1 0 auto"}
                className={"wc cambio"}
                css={css`animation: ${Transition} 1s cubic-bezier(0.075, 0.82, 0.165, 1) 1;`}
            >
            <ConFacturaCard>
                <AlertDialog
                    titulo={'Información de la factura'}
                    icono={'fa fa-info-circle fa-lg'}
                    subtitulo={'Resumen de la factura'}
                    data={this.state.showModal.data}
                    closeModal={this.showModal}
                    visible={this.state.showModal.activo}
                />
                {!this.state.procesando &&
                <Mycard
                    bgT
                    className={`col-12 mx-auto px-0 ${
                        (this.state.opcionesRecaudo !== "" && this.state.opcionesRecaudo) &&
                         "col-" + (9 + (1* Number(this.state.opcionesRecaudo.multiplesValoresPago.opcion)))} `}
                    title={"Listado"}
                    back={ruta.home}
                    visible
                    footer={
                        this.state.opcionesRecaudo !== "" && this.state.opcionesRecaudo && this.state.opcionesRecaudo.agruparFacturas.activo &&
                        <FooterL
                            loading={this.state.loading}
                            total={this.state.totalPagar}
                            moneda={this.state.moneda}
                            disableButton={this.state.allCheck || (this.state.checks.length > 0 && facturaSeleccionada.length > 0)}
                            pagarFacturas={() => this.pagarFacturas()}
                        />
                    }
                    history={this.props.history}
                >

                    <div className="wc px-2 px-lg-4">
                        <CustomizedSnackbars
                            message={this.state.showMessage.message}
                            type={'info'}
                            visible={this.state.showMessage.open}
                            isClosed={true}
                            onClose={this.closedAlert}
                        />
                        {(this.state.opcionesRecaudo !== "" && this.state.opcionesRecaudo && this.state.opcionesRecaudo.agruparFacturas.activo) &&
                            <Flex className="wc cb pb-3 pl-3 " jc={"flex-start"}>
                                <Mycheck active={this.state.allCheck}
                                         clickCheck={this.onChangeCheck.bind(this)}
                                         all={true}/>
                                <small className={"mb-0 ml-3"}>Seleccionar todas</small>
                            </Flex>
                        }
                        {this.state.cambiarPantalla
                                ?
                                    <AbonoMultiplesValores
                                        clickCheck={this.onChangeCheck.bind(this)}
                                        {...this.state}
                                        onChangeOtroValor={this.onChangeOtroValor.bind(this)}
                                        clickCheckOtroValor={this.clickCheckOtroValor.bind(this)}
                                        salirCambiarPantalla={() => this.salirCambiarPantalla()}
                                    />
                                :
                                    <Factura
                                        pagar={this.pagar.bind(this)}
                                        clickCheck={this.onChangeCheck.bind(this)}
                                        loadFunc={this.loadFunc.bind(this)}
                                        {...this.state}
                                        clickCheckOtroValor={this.clickCheckOtroValor.bind(this)}
                                        onChangeOtroValor={this.onChangeOtroValor.bind(this)}
                                        clickCheckValor1={this.clickCheckValor1.bind(this)}
                                        clickCheckValor2={this.clickCheckValor2.bind(this)}
                                        clickCheckValor3={this.clickCheckValor3.bind(this)}
                                        showModal={this.showModal}
                                        validator={this.validator}
                                        opcionesRecadudo={this.state.opcionesRecaudo}
                                    />
                        }
                    </div>
                </Mycard>
                }
            </ConFacturaCard>
            </Elastic>
        )
    }
}


export default withRouter(Listafacturas);
